import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Form, Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DriverSelector from "../../components/driverSelector";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";  // Імпорт іконок
import { useTranslation } from 'react-i18next';



const ExtraFunds = () => {
    const { t } = useTranslation();

    const [funds, setFunds] = useState([]);
    const [filters, setFilters] = useState({ user_id: null }); // user_id тепер { value, label }
    const navigate = useNavigate();

    useEffect(() => {
        fetchFunds();
    }, []);

    const fetchFunds = async () => {
        try {
            const response = await axios.get("https://godrive.com.pl/api/extraFunds");
            console.log(response);
            const sortedFunds = response.data
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .slice(0, 100);
            setFunds(sortedFunds);
        } catch (error) {
            console.error("Error fetching extra funds", error);
        }
    };

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleEdit = (id) => {
        navigate(`/admin/edit-extra-funds/${id}`);
    };

    // Фільтрація таблиці по вибраному водію
    const filteredFunds = funds.filter(fund =>
        filters.user_id ? fund.driver_id.toString() === filters.user_id.value.toString() : true
    );

    const handleDelete = async (id) => {
        if (!window.confirm(t("deleteQuestion"))) {
            return;
        }

        try {
            await axios.delete(`https://godrive.com.pl/api/extraFunds/${id}`);
            fetchFunds(); // Оновити список після видалення
        } catch (error) {
            console.error("Error deleting extra fund", error);
            alert(t("deleteFalseMessage"));
        }
    };

    return (
        <Container>
            <h2>{t("extraCosts")}</h2>
            <Form>
            <Form.Group>
                    <DriverSelector 
                        selectedDriver={filters.user_id} 
                        setSelectedDriver={(selectedOption) => setFilters({ ...filters, user_id: selectedOption })} 
                    />
                </Form.Group>
            </Form><div className="mt-4 d-flex justify-content-left">
            <a href="/admin/edit-extra-funds" className="btn btn-danger">{t("create")}</a>
            </div>
            <h3 className="mt-4">{t("listOf")} {t("extraCosts").toLocaleLowerCase()}</h3>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>{t("driver")}</th>
                        <th>{t("week")}</th>
                        <th>{t("vat")}</th>
                        <th>{t("zus")}</th>
                        <th>{t("partner")}</th>
                        <th>{t("accountant")}</th>
                        <th>{t("carRent")}</th>
                        <th>{t("sallary")}</th>
                        <th>{t("other")}</th>
                        <th>{t("refunds")}</th>
                        <th>{t("actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredFunds.map((fund) => (
                        <tr key={fund.id}>
                            <td>{fund.firstName} {fund.lastName}</td>
                            <td>{fund.week_number}</td>
                            <td>{fund.returnVat}</td>
                            <td>{fund.taxesZus}</td>
                            <td>{fund.partner}</td>
                            <td>{fund.accountant}</td>
                            <td>{fund.carRent}</td>
                            <td>{fund.sallary}</td>
                            <td>{fund.other}</td>
                            <td>{fund.refunds}</td>
                            <td>
                                <AiOutlineEdit 
                                                    style={{ cursor: "pointer", marginRight: "10px", color: "orange" }} 
                                                    size={20} 
                                                    onClick={() => handleEdit(fund.id)} 
                                                  />
                                <AiOutlineDelete 
                                                    style={{ cursor: "pointer", color: "red" }} 
                                                    size={20} 
                                                    onClick={() => handleDelete(fund.id)} 
                                                  />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            
            
        </Container>
        
    );
};

export default ExtraFunds;
